import { useRef, useImperativeHandle, forwardRef } from 'react';

import { KoobLoader, KoobSearchBar } from '@koob/ui';
import { useTranslation } from 'react-i18next';

const Search = (
  {
    variant,
    onChange,
    placeholder,
    size,
    value,
    isLoading,
    onClear = () => {},
    ...props
  },
  ref,
) => {
  const inputRef = useRef();
  const { t } = useTranslation('misc');

  useImperativeHandle(ref, () => ({
    focus: () => {
      if (Boolean(inputRef.current)) {
        inputRef.current.focus();
      }
    },
  }));

  return (
    <KoobSearchBar
      ref={inputRef}
      onChange={onChange}
      value={value}
      placeholder={placeholder || t('search')}
      autoComplete="none"
      data-testid="search-input"
      aria-label={t('search')}
      iconRight={
        isLoading ? (
          <KoobLoader size={16} color="currentColor" className="mr-3" />
        ) : Boolean(value) ? (
          <i className="fa-light fa-circle-xmark" style={{ fontSize: 20 }} />
        ) : null
      }
      onIconRightClick={
        Boolean(value) && !isLoading
          ? () => {
              onChange('');
              onClear();
            }
          : undefined
      }
      {...props}
    />
  );
};

export default forwardRef(Search);
